import { Trans } from "react-i18next"

import FormattedComment from "components/lib/FormattedComment"
import util from "utils/utils"

export default function IdeaCommentReply({ events, ownerIdea }) {
  return (
    <Trans
      i18nKey="notifications.ideaCommentReplied"
      values={{
        name: util.getEventNames(events),
        idea: ownerIdea?.name || "Deleted",
        comment: events[0]?.comment || "",
      }}
      components={{
        b: <b />,
        formattedComment: <FormattedComment noLink />,
      }}
    />
  )
}
